import React from 'react';

interface EmptyRowProps {
  text: string;
  colSpan: number;
}

const EmptyRow: React.FC<EmptyRowProps> = ({ text, colSpan }) => {
  return (
    <tr>
      <td colSpan={colSpan} className="text-center py-5">
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px', padding: '40px 16px' }}>
          <span style={{ fontFamily: 'var(--font-sans)', fontSize: '11px', textTransform: 'uppercase', letterSpacing: '0.18em', color: 'var(--dim)' }}>
            {text}
          </span>
          <span style={{ display: 'block', height: '1px', width: '48px', background: 'linear-gradient(to right, var(--acc), transparent)' }} />
        </div>
      </td>
    </tr>
  );
};

export default EmptyRow;
